import { CalculationType } from "../../../../../../../../../../api/types/fieldConfigurationTypes";
import type { CustomColumnField, ReportField } from "../../../../../../../../../../api/types/svTypes";
import { isCustomColumn } from "../../../../../../utilities/fieldsHelper";

export const findExistingCustomFormulaField = (
  fields: ReportField[],
  fieldGuid: string | undefined
): CustomColumnField | undefined => {
  if (fieldGuid === undefined) {
    return undefined;
  }

  const field = fields.find((item) => item.config.guid === fieldGuid);
  if (field === undefined || !isCustomColumn(field)) {
    return undefined;
  }

  if (field.config.calculationType !== CalculationType.CustomFormula) {
    return undefined;
  }

  return field;
};
